import React, { useState, useEffect } from 'react';
import { brandGradients } from '../theme/palette';
import logo from '../logo.svg'; // Make sure to place your logo.jpg in the same directory

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { name: 'Home', id: 'hero' },
    { name: 'About Us', id: 'about' },    
    { name: 'Vision & Strength', id: 'vision' },
    { name: 'Services', id: 'services' },
    { name: 'Clients & Empanelments', id: 'experience' },
    { name: 'Team', id: 'team' },    
    { name: 'Contact Us', id: 'contact' }
  ];

  return (
    <>
      {/* Header is forced to stay white at all times; only vertical padding shrinks on scroll */}
  <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-1xl backdrop-blur-sm py-1">
  <div className="container">
          <div className="flex items-center justify-between">
            {/* Logo Section */}
            <div className="flex items-center" onClick={() => scrollToSection('hero')}>
              <div className="cursor-pointer">
                {/* Logo Image with extra width */}
                <div className="w-28 h-20 md:w-32 md:h-24 rounded-xl flex items-center justify-center overflow-hidden transition-all duration-300">
                  <img 
                    src={logo} 
                    alt="RLDS Logo" 
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="font-semibold text-sm lg:text-base transition-all duration-300 hover:scale-105 relative group text-gray-700 hover:text-blue-600"
                >
                  {item.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-300"></span>
                </button>
              ))}
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg"
                style={{ background: brandGradients.panel }}
              >
                <i className="fas fa-phone mr-2"></i>
                Get in Touch
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 rounded-lg transition-colors text-gray-700 hover:bg-gray-100"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-2xl border-t border-gray-100 animate-fade-in-down">
              <nav className="flex flex-col py-4">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-700 font-medium text-left px-6 py-3 hover:bg-blue-50 hover:text-blue-600 transition-colors text-base"
                  >
                    {item.name}
                  </button>
                ))}
                <div className="px-6 pt-4">
                  <button 
                    onClick={() => scrollToSection('contact')}
                    className="w-full text-white py-3 rounded-full font-semibold"
                    style={{ background: brandGradients.panel }}
                  >
                    <i className="fas fa-phone mr-2"></i>
                    Get in Touch
                  </button>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;